// Texty stránky Stav objednávky, slovenské dvojča locale/cs/orderStatusPage.js.
// Chat ani predajňu SK nemá: vety „napíšte nám" vedú na e-mail.
import { CONTACT } from '../../modules/headerTools.js';
import { page } from '../../modules/pages.js';
import { plural } from '../plural.js';

const MINUTES = ['minútu', 'minúty', 'minút'];
// věta končící datem („8. 10.") už tečku má
const end = (s) => (/\.$/.test(s) ? s : s + '.');
const via = (chat) => (chat ? 'do chatu' : 'na ' + CONTACT.email);

export default {
  eyebrow: 'Sledovanie zásielky',
  perex: 'Zadajte číslo objednávky a e-mail, ktorý ste vyplnili pri nákupe. Uvidíte, kde objednávka je a kedy dorazí.',

  form: {
    title: 'Zistiť stav objednávky',
    sub: 'Oba údaje nájdete v potvrdzovacom e-maile',
    code: 'Číslo objednávky',
    // čísla SK objednávok majú 10 číslic ako CZ (ostrá SK 8. 10. 2026: 2261…)
    codePlaceholder: 'napr. 2261004387',
    email: 'E-mail',
    emailPlaceholder: 'jan.novak@email.sk',
    fromAccount: 'Predvyplnili sme e-mail z vášho účtu.',
    submit: 'Zobraziť stav',
    searching: 'Hľadáme…',
    retry: 'Skúsiť znova',
    lockedFor: (n) => 'Skúsiť o ' + n + ' ' + plural(n, MINUTES),
    privacy: 'Bez registrácie. Stav uvidí len ten, kto pozná číslo objednávky aj e-mail.',
    missingCode: 'Doplňte číslo objednávky.',
    missingEmail: 'Doplňte e-mail z objednávky.',
  },

  memory: {
    label: 'Naposledy ste hľadali',
    show: 'Zobraziť stav',
    forget: 'Zabudnúť',
  },

  alert: {
    notFound: {
      title: 'Objednávku sme nenašli',
      text: 'Skontrolujte číslo objednávky a e-mail. Platí len e-mail, ktorý ste vyplnili pri nákupe.',
      text2: (chat) => 'Keď ju stále nenájdete, napíšte nám ' + via(chat) + ' a dohľadáme ju.',
    },
    locked: {
      title: 'Príliš veľa pokusov',
      text: (min, chat) =>
        'Z bezpečnostných dôvodov sme hľadanie na chvíľu zastavili. Skúste to znova o ' +
        min + ' ' + plural(min, MINUTES) +
        ', alebo nám napíšte ' + via(chat) + '.',
    },
    outage: {
      title: 'Stav objednávky teraz nedokážeme načítať',
      text: (chat) =>
        'Výpadok je na našej strane. Skúste to o pár minút, alebo nám napíšte číslo objednávky ' +
        via(chat) + ' a stav vám povieme.',
    },
    chat: 'Napísať do chatu',
    mail: 'Napísať e-mail',
  },

  loading: {
    title: (code) => 'Načítavame objednávku ' + code + '…',
    fromLink: 'Otvorili ste odkaz z e-mailu, nič vypĺňať nemusíte.',
    fromMemory: 'Hľadáme podľa údajov, ktoré ste zadali minule.',
  },

  orderNo: (code) => 'Objednávka ' + code,
  updated: (when) => 'Aktualizované ' + when,
  updatedAt: (day, time) => (day ? day + ' o ' + time : 'dnes o ' + time),
  staleAt: (time) => 'Stav k ' + time,
  stale: (time) => 'Údaje sú z ' + time + '. Novší stav sa teraz nepodarilo načítať, skúste stránku o chvíľu obnoviť.',
  refresh: 'Obnoviť',

  status: {
    waitTransfer: { title: 'Čaká na platbu', text: 'Údaje k platbe aj QR kód nájdete nižšie.' },
    waitTransferNoQr: { title: 'Čaká na platbu', text: 'Údaje k platbe nájdete nižšie.' },
    waitCard: { title: 'Čaká na platbu', text: 'Platba kartou neprebehla. Zaplatiť môžete znova nižšie.' },
    // stav „platba sa overuje" (SK zatiaľ nemá, kľúč kvôli dvojčatám)
    paymentPending: { title: 'Overujeme platbu', text: 'Platbu teraz priraďujeme k objednávke, znova neplaťte. Keby niečo nesedelo, ozveme sa.' },
    paymentUnverified: { title: 'Objednávka prijatá', text: 'Platobné údaje nájdete v e-maile s potvrdením objednávky.' },
    received: { title: 'Objednávka prijatá', text: 'Objednávku máme a čoskoro ju začneme chystať.' },
    preparing: {
      title: 'Pripravujeme na odoslanie',
      text: 'Platbu máme. Hneď ako zásielku odovzdáme dopravcovi, pošleme vám e-mail s číslom zásielky.',
    },
    // dobírka i nezaplacená objednávka v přípravě: text bez slibu platby (Tomáš 8. 10. 2026)
    preparingCod: {
      title: 'Pripravujeme na odoslanie',
      text: 'Hneď ako zásielku odovzdáme dopravcovi, pošleme vám e-mail s číslom zásielky.',
    },
    preparingStore: {
      title: 'Pripravujeme na vyzdvihnutie',
      text: 'Hneď ako bude objednávka pripravená na vyzdvihnutie, pošleme vám e-mail.',
    },
    shipped: {
      title: 'Odovzdané dopravcovi',
      text: (carrier, when) =>
        (carrier ? 'Zásielku vezie ' + carrier + '.' : 'Zásielku vezie dopravca.') +
        (when ? ' Doručenie predpokladáme ' + end(when) : ''),
    },
    pickupReady: {
      title: 'Čaká na výdajnom mieste',
      text: (carrier) => 'Zásielku si môžete vyzdvihnúť na výdajnom mieste' + (carrier ? ' ' + carrier : '') + '.',
    },
    storeReady: { title: 'Pripravené na vyzdvihnutie', text: 'Objednávka na vás čaká na vyzdvihnutie.' },
    delivered: { title: 'Doručené', text: (when) => (when ? end('Zásielku ste prevzali ' + when) : 'Objednávku sme vybavili.') },
    pickedUp: { title: 'Vyzdvihnuté', text: (when) => (when ? end('Objednávku ste vyzdvihli ' + when) : 'Objednávku sme vybavili.') },
    cancelled: {
      title: 'Objednávka je zrušená',
      text: (when) => (when ? end('Objednávku sme zrušili ' + when) : 'Objednávku sme zrušili.'),
    },
    returned: { title: 'Vrátenie alebo reklamácia', text: 'Vrátenie alebo reklamáciu riešime. O ďalšom postupe vám napíšeme e-mailom.' },
    processing: {
      title: 'Objednávku spracúvame',
      text: (chat) => 'Na objednávke práve pracujeme. Keby vám niečo nesedelo, napíšte nám ' + via(chat) + '.',
    },
  },

  stepsTitle: 'Priebeh objednávky',
  step: {
    received: 'Objednávka prijatá',
    paid: 'Zaplatené',
    payment: 'Platba',
    waitPay: 'Čaká na platbu',
    paymentPending: 'Overujeme platbu',
    cod: 'Platba pri prevzatí',
    preparing: 'Pripravujeme na odoslanie',
    shipped: 'Odovzdané dopravcovi',
    pickupReady: 'Pripravené na vyzdvihnutie',
    pickedUp: 'Vyzdvihnuté',
    delivered: 'Doručené',
    cancelled: 'Zrušené',
    returned: 'Vrátenie alebo reklamácia',
  },
  stepMeta: {
    payTransfer: (amount) => 'prevodom, ' + amount,
    payCard: (amount) => 'kartou online, ' + amount,
    payOther: (amount) => amount,
    cod: (amount) => 'na dobierku, ' + amount,
    afterPayment: 'po pripísaní platby',
    afterCard: 'po zaplatení',
    atPickup: 'na výdajnom mieste',
    estimate: (day) => 'predpoklad ' + day,
    store: 'predajňa',
  },

  pay: {
    title: 'Zaplaťte prevodom',
    qrAlt: (amount) => 'QR kód pre platbu ' + amount,
    qrCaption: 'Naskenujte v aplikácii banky',
    amount: 'Suma',
    account: 'Číslo účtu',
    vs: 'Variabilný symbol',
    copy: (what) => 'Kopírovať ' + what,
    copyWhat: { amount: 'sumu', account: 'číslo účtu', vs: 'variabilný symbol', tracking: 'číslo zásielky' },
    copied: 'Skopírované',
    copyFailed: 'Kopírovanie sa nepodarilo, skopírujte text ručne.',
    bankLine: (iban, bic) => 'IBAN ' + iban + ' · BIC ' + bic,
    note: 'Hneď ako platba príde na účet, pošleme vám e-mail a objednávku začneme chystať.',
    cardTitle: 'Dokončite platbu kartou',
    cardText: 'Objednávku máme, chýba len platba.',
    cardCta: (amount) => 'Zaplatiť online ' + amount,
  },

  ship: {
    destPickup: 'Doručenie na výdajné miesto',
    destAddress: 'Doručenie na adresu',
    destStore: 'Osobný odber na predajni',
    trackTitle: 'Zásielka',
    trackNo: 'Číslo zásielky',
    trackState: {
      in_transit: 'Na ceste',
      ready_for_pickup: 'Na výdajnom mieste',
      delivered: 'Doručené',
      failed: 'Doručenie sa nepodarilo',
      carrier_issue: 'Dopravca rieši problém so zásielkou',
    },
    trackUpdated: (state, when) => (state ? state + ', aktualizované ' : 'Aktualizované ') + when,
    follow: (carrier) => (carrier ? 'Sledovať u ' + carrier : 'Sledovať zásielku'),
    estimate: 'Predpoklad doručenia',
    pickupTitle: 'Kde zásielku vyzdvihnete',
    pickupNote: 'Ako zásielku vyzdvihnúť, nájdete v sledovaní u dopravcu.',
    storeTitle: 'Vyzdvihnutie na predajni',
    storeName: 'Predajňa Jipos',
    openToday: (hour) => 'Dnes otvorené do ' + hour,
    closedOpens: (when, hour) => 'Zatvorené, otvárame ' + when + ' o ' + hour,
    map: 'Otvoriť v mapách',
  },

  returns: {
    title: 'Vrátenie a reklamácia',
    returnTitle: 'Vrátiť do 14 dní',
    returnText: (until) => 'Bez udania dôvodu. ' + (until ? end('Lehota plynie do ' + until) : 'Lehota plynie 14 dní od prevzatia.'),
    returnCta: 'Odstúpiť od zmluvy',
    claimTitle: 'Reklamovať chybu',
    claimText: 'Vybavíme najneskôr do 30 dní.',
    claimCta: 'Reklamačný formulár',
  },

  /** Samoobslužné storno (prepínač orderCancel, API `order-status/cancel`) */
  abort: {
    title: 'Zrušenie objednávky',
    text: 'Objednávku môžete zrušiť sami, kým ju nezačneme baliť.',
    cta: 'Zrušiť objednávku',
    confirm: (code) => 'Zrušiť objednávku ' + code + '?',
    confirmText: 'Zrušenie sa nedá vrátiť. Potvrdenie vám pošleme e-mailom.',
    yes: 'Áno, zrušiť',
    no: 'Ponechať objednávku',
    working: 'Rušíme…',
    done: 'Objednávka je zrušená.',
    tooLate: (chat) => 'Objednávku už pripravujeme, sami ju zrušiť nemôžete. Napíšte nám ' + via(chat) + '.',
    failed: 'Objednávku teraz nie je možné zrušiť. Skúste to o chvíľu.',
    locked: 'Príliš veľa pokusov. Skúste to o chvíľu.',
  },

  cancelled: {
    title: 'Platba zrušenej objednávky',
    text: (chat) => 'Ak ste objednávku už zaplatili a peniaze sa vám zatiaľ nevrátili, napíšte nám ' + via(chat) + '.',
    cta: 'Pokračovať v nákupe',
  },

  items: {
    title: 'Obsah objednávky',
    count: ['položka', 'položky', 'položiek'],
    code: (code) => 'Kód ' + code,
    shipping: (name) => 'Doprava: ' + name,
    billing: (name) => 'Platba: ' + name,
    gift: 'Darček',
    extra: {
      'discount-coupon': 'Zľavový kupón',
      'volume-discount': 'Množstevná zľava',
      'gift-certificate': 'Darčeková poukážka',
      service: 'Služba',
      'generic-item': 'Ďalšia položka',
      deposit: 'Záloha na obal',
      other: 'Ďalšia položka',
    },
    rounding: 'Zaokrúhlenie',
    free: 'zadarmo',
    totalToPay: 'Celkom na úhradu',
    totalPaid: 'Celkom zaplatené',
    total: 'Celkom',
    vat: 'vrátane DPH',
    invoice: (code) => 'Faktúra ' + code,
    creditNote: (code) => 'Opravný doklad ' + code,
    pdf: 'PDF',
    download: 'Stiahnuť faktúru',
    downloadCredit: 'Stiahnuť doklad',
    downloading: 'Sťahujeme…',
    downloadFailed: 'Doklad sa teraz nepodarilo stiahnuť. Skúste to o chvíľu.',
    downloadLocked: 'Príliš veľa sťahovaní naraz. Skúste to o minútu.',
    fileInvoice: 'faktura',
    fileCreditNote: 'dobropis',
  },
  manuals: {
    title: (n) => (n > 1 ? 'Návody k vašim produktom' : 'Návod k vášmu produktu'),
    sub: 'PDF otvoríte v telefóne aj v počítači.',
    meta: (file) => 'Návod na použitie' + (file ? ' · ' + file : ''),
    cta: 'Stiahnuť návod',
    none: 'K produktom v tejto objednávke tu návod zatiaľ nie je. Odpovedzte na náš e-mail a návod vám pošleme.',
    aria: (name, file) => 'Stiahnuť návod k produktu ' + name + (file ? ' (' + file + ')' : ''),
  },
  another: 'Zadať inú objednávku',

  whereTitle: 'Kde nájdem číslo objednávky?',
  where: [
    { icon: 'mail', title: 'V potvrdzovacom e-maile', desc: 'v predmete aj v texte e-mailu, ktorý prišiel po objednaní' },
    { icon: 'user', title: 'V sekcii Moje objednávky', desc: 'po prihlásení do účtu', href: page('accountOrders') },
    { icon: 'file', title: 'Na faktúre', desc: 'v hlavičke dokladu' },
  ],
  whereNote: ['Číslo zadajte ', 'bez medzier', ', presne ako v e-maile.'],

  faqTitle: 'Časté otázky',
  faqAll: 'Všetky časté otázky',
  faq: {
    ship: { q: 'Kedy objednávku odošlete?', a: 'Tovar skladom odosielame v deň objednania, keď objednáte v pracovný deň do 15:00, v piatok do 14:30. Pri platbe prevodom až po pripísaní sumy na účet.' },
    shipPrep: { q: 'Kedy objednávku odošlete?', a: 'Tovar skladom odosielame v deň objednania, keď objednáte v pracovný deň do 15:00, v piatok do 14:30. Termín odoslania vidíte pri každom produkte aj v košíku.' },
    invoice: { q: 'Kedy dostanem faktúru?', a: 'Faktúru dostanete e-mailom. Keď ju nemôžete nájsť, napíšte nám číslo objednávky a pošleme ju znova.' },
    change: { q: 'Môžem objednávku zrušiť alebo zmeniť?', a: 'Áno, kým ju neodošleme. Napíšte nám čo najskôr na ' + CONTACT.email + '.' },
    /** stránka ponúka storno tlačidlom (cancelOf) */
    changeSelf: {
      q: 'Môžem objednávku zrušiť alebo zmeniť?',
      a: 'Zrušiť ju môžete sami tlačidlom „Zrušiť objednávku“ na tejto stránke, kým ju nezačneme baliť. Zmenu adresy, dopravy alebo tovaru vybavíme, keď nám napíšete na ' + CONTACT.email + '.',
    },
    where: { q: 'Kde je môj balík a kedy dorazí?', a: 'Hneď ako balík odovzdáme dopravcovi, príde vám e-mail s číslom zásielky. Cestu potom sledujete tu alebo priamo u dopravcu.' },
    track: { q: 'Kde je môj balík a kedy dorazí?', a: 'Cestu zásielky sledujete priamo u dopravcu. Keď nedorazí v termíne, ktorý vám dopravca poslal, napíšte nám číslo objednávky a zásielku dohľadáme.' },
    addr: { q: 'Môžem zmeniť adresu alebo výdajné miesto?', a: 'Odoslanú zásielku už zmeniť nejde. Prevezmite ju a prípadne využite vrátenie do 14 dní.' },
    refuse: { q: 'Čo keď zásielku neprevezmem?', a: 'Neprevzatie nie je odstúpenie od zmluvy. Náklady na dopravu tam aj späť vám podľa obchodných podmienok vyúčtujeme.' },
    storeWhere: { q: 'Kde predajňu nájdem?', a: 'Adresu a otváracie hodiny nájdete na stránke Kontakt.' },
    ret: { q: 'Ako vrátim tovar do 14 dní?', a: 'Vyplňte online formulár Odstúpenie v lehote 14 dní a tovar pošlite späť do 14 dní od odstúpenia. Peniaze vraciame do 14 dní od odstúpenia, hneď ako tovar dorazí späť alebo doložíte jeho odoslanie.' },
    claim: { q: 'Ako reklamujem chybný tovar?', a: 'V reklamačnom formulári vyplníte číslo objednávky, e-mail a popis chyby, pomôže aj fotka alebo video. Reklamáciu vybavíme najneskôr do 30 dní.' },
    warranty: { q: 'Aká dlhá je záruka?', a: 'Pri spotrebnom tovare môžete chybu vytknúť do dvoch rokov od prevzatia.' },
    pay: { q: 'Ako môžem zaplatiť?', a: 'Kartou online, bankovým prevodom alebo na dobierku pri prevzatí. Prehľad je na stránke Doprava a platba.' },
  },

  help: {
    form: {
      title: 'Niečo nesedí?',
      text: 'Nemôžete objednávku nájsť alebo vám stav nesedí? Ozvite sa, hneď sa na to pozrieme.',
    },
    pre: {
      title: 'Potrebujete objednávku zrušiť alebo zmeniť?',
      text: (chat) =>
        chat
          ? 'Kým ju neodošleme, zrušíme ju alebo upravíme. Napíšte nám do chatu, číslo objednávky doplníme za vás.'
          : 'Kým ju neodošleme, zrušíme ju alebo upravíme. Napíšte nám e-mail, číslo objednávky doplníme za vás.',
    },
    // zrušiť ide tlačidlom na stránke (cancelOf), panel ponúka len zmenu
    preCancel: {
      title: 'Potrebujete objednávku zmeniť?',
      text: (chat) =>
        chat
          ? 'Adresu, dopravu alebo tovar upravíme, kým objednávku neodošleme. Napíšte nám do chatu, číslo objednávky doplníme za vás.'
          : 'Adresu, dopravu alebo tovar upravíme, kým objednávku neodošleme. Napíšte nám e-mail, číslo objednávky doplníme za vás.',
    },
    post: {
      title: 'Niečo nesedí?',
      text: (chat) =>
        chat
          ? 'Napíšte nám do chatu alebo e-mailom, číslo objednávky doplníme za vás.'
          : 'Napíšte nám e-mail, číslo objednávky doplníme za vás.',
    },
    chat: 'Napísať do chatu',
    mail: 'Napísať e-mail',
    hours: (text) => 'Podpora ' + text,
    subject: (code) => 'Objednávka ' + code,
    chatDraft: (code, email) => 'Objednávka ' + code + ', e-mail ' + email + ': ',
  },

  dayName: ['nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota'],
  dayAbbr: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
  dayUntil: ['nedele', 'pondelka', 'utorka', 'stredy', 'štvrtka', 'piatku', 'soboty'],
  today: 'dnes',

  carriers: { ppl: 'PPL', gls: 'GLS', fofr: 'Fofr', zasilkovna: 'Packeta', dpd: 'DPD', cp: 'Slovenská pošta', balikovna: 'Balíkovňa' },
  carrierRe: [
    [/\bPPL\b/i, 'ppl'],
    [/\bGLS\b/i, 'gls'],
    [/\bfofr\b/i, 'fofr'],
    [/z[áa]siel?kov|packeta/i, 'zasilkovna'],
    [/\bDPD\b/i, 'dpd'],
    [/bal[íi]kov/i, 'balikovna'],
    [/slovensk[áa]\s+po[šs]ta/i, 'cp'],
  ],
  storeRe: /osobn[ýy]\s*odber|predaj/i,
};
